<script>
</script>

<div class="concierge-chat-skeleton-avatar"></div>

<style>
  .concierge-chat-skeleton-avatar {
    float: left;
    width: 30px;
    height: 30px;
    background-color: #ccc;
    border-radius: 50%;
    background-image: linear-gradient(90deg, #ddd 0px, #e8e8e8 40px, #ddd 80px);
    background-size: 100px;
    animation: shine-avatar 1.6s infinite linear;
  }

  @keyframes shine-avatar {
    0% {
      background-position: -200px 0;
    }

    100% {
      background-position: 200px 0;
    }
  }
</style>
